import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApplicationDates,
  setApplicationDates,
  UpdateApplicationStatus,
} from "../adminApi";
import {
  SetApplicationDatesDto,
  UpdateApplicationStatusDto,
} from "../models";

export const setApplicationDatesThunk = createAsyncThunk(
  "setApplicant/Dates",
  async (payload: SetApplicationDatesDto) => {
    let response: any;
    await setApplicationDates(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const UpdateApplicationStatusThunk = createAsyncThunk(
  "update/status",
  async (payload: UpdateApplicationStatusDto) => {
    let response: any;
    await UpdateApplicationStatus(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const getApplicationDatesThunk = createAsyncThunk(
  "getApplicant/Dates",
  async () => {
    let response: any;
    await getApplicationDates()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);